import axios from 'axios'

import { URL_PREFIX } from '../config'

export const getArtistPayments = (page, pageSize = 12, sort, filters, search, artistId, cancelToken=null) => {
  return axios.get(URL_PREFIX + '/artist-payments/', {
     params: {
      artist: artistId,
      ordering: sort,
      search: search,
      fromDateFilter: filters?.start?.value,
      toDateFilter: filters?.end?.value,
      paymentFilter: filters?.paymentFilter?.value,
      page: page,
      page_size: pageSize,
    },
    cancelToken: cancelToken?.token
  })
}

export const postArtistPayments = (params) => {
  return axios.post(URL_PREFIX + '/artist-payments/', params)
}

export const patchArtistPayments = (id, params) => {
  return axios.patch(URL_PREFIX + '/artist-payments/' + id + '/', params)
}

export const deleteArtistPayments = (id) => {
  return axios.delete(URL_PREFIX + '/artist-payments/' + id + '/')
}
